export const GET_MESSAGES_REQUEST = 'chat/GET_MESSAGES_REQUEST';
export const GET_MESSAGES_SUCCESS = 'chat/GET_MESSAGES_SUCCESS';
export const GET_MESSAGES_FAILURE = 'chat/GET_MESSAGES_FAILURE';

export const GET_USERS_REQUEST = 'chat/GET_USERS_REQUEST';
export const GET_USERS_SUCCESS = 'chat/GET_USERS_SUCCESS';
export const GET_USERS_FAILURE = 'chat/GET_USERS_FAILURE';

export const SET_AUTO_MESSAGE = 'chat/SET_AUTO_MESSAGE';